import { catchError, from, of, mergeMap, switchMap, map, filter } from 'rxjs';
import { ofType } from 'redux-observable';
import getUserProfile$ from '../apis/getUserProfile';
import getUserFavorites$ from '../apis/getUserFavorites';
import { userProfileSlice } from './slices';
import saveUserFavorite from '../apis/saveFavorite';
import deleteUserFavorite from '../apis/deleteFavorite';
import getFavoriteFromState from '../services/getFavoriteFromState';
import housingProductConstructor from '../services/getHousingProductType';

const actions = userProfileSlice.actions;

// this epic requests the profile data for logged in users.
export const fetchUserProfileEpic = (action$) =>
  action$.pipe(
    ofType(actions.fetch.type),
    switchMap(() =>
      getUserProfile$.pipe(
        switchMap((response) => from(response.json()).pipe(mergeMap((data) =>
        of(actions.apply(data))))),
        catchError((err) => of(actions.handleError(err)))
      )
    )
  );

// this epic requests the profile data for logged in users.
export const fetchUserFavoritesEpic = (action$) =>
  action$.pipe(
    ofType(actions.apply.type),
    filter((action) => action.payload && action.payload.IsLogin === true),
    switchMap(() =>
      getUserFavorites$.pipe(
        switchMap((response) => from(response.json()).pipe(mergeMap((data) =>
        of(actions.applyFavorites(data))))),
        catchError((err) => of(actions.handleError(err)))
      )
    )
  );

// this epic is triggered when the user profile is loaded
// it loads the user's favorites into the favorites slice.
export const getUserFavoritesEpic = (action$) =>
  action$.pipe(
    ofType(actions.apply.type),
    map((action) => actions.loadFavorites(action.payload))
  );

// this epic is triggered when the user clicks on the favorite icon on a card 
// that is not already a favorite. 
export const saveFavoriteEpic = (action$, state$) => 
action$.pipe( 
  ofType(actions.saveFavorite.type),
  filter(() => state$.value?.userProfile?.isLogin),
  mergeMap((action) => { 
    const { listingInformation, type, url, userId } = action.payload;
    const housingProductType = housingProductConstructor(type, listingInformation);
    const saveInformation = {
      id: listingInformation.id,
      type,
      url,
      userId
    };
    return saveUserFavorite(saveInformation).pipe(
      switchMap((data) => of(actions.saveFavoriteFulfilled({data, housingProductType})))
    );
}));

// this epic is triggered when the user clicks on the favorite icon on a card
// that is already a favorite.
export const deleteFavoriteEpic = (action$, state$) =>
  action$.pipe(
    ofType(actions.deleteFavorite.type),
    switchMap((action) => {
      const payload = action.payload;
      
      // get the favorite from the state that matches the action.payload.id
      const favorite = getFavoriteFromState(state$.value, Number(payload.listingInformation.id));

      return deleteUserFavorite(favorite.id).pipe(
        switchMap(() => of(actions.deleteFavoriteFullfilled(favorite)))
      );
    }));